module.exports = __webpack_public_path__ + "c10448feb0468936643980526e1d5c25.m4a";